module.exports = __webpack_public_path__ + "src/assets/img/okkoonline.c4c096cd.jpg";